import React from "react";
import { createPortal } from "react-dom";
import { useSelector } from "../../../../../chronusStore/helper";
import navigationEventTracker from "../tracker/navigationEventTracker";

const SideBarHorizontalTabs = () => {

  const HORIZONTAL_PLACEHOLDER_DIV = "horizontal-tab-react";

  const sections = useSelector((state) => state.leftNav.sections);
  const tabs = sections?.map(section => section.tabs)?.flat();

  const clickHandler = (tab) => {
    if(document.getElementById(HORIZONTAL_PLACEHOLDER_DIV)){
      var trackingInfo = {
          ...tab.trackingInfo,
          menu_type: chrEventConstants.menuType.NON_LOGGED_IN_OVERVIEW_PAGES_LIST_NAVIGATION
        }
      }
    navigationEventTracker(trackingInfo)
  };

  return (
    <>
      {document.getElementById(HORIZONTAL_PLACEHOLDER_DIV) &&
        createPortal(
          tabs && tabs.length > 0 && tabs.map((tab, index) => (
              <li key={index} onClick={() => { clickHandler(tab) }} className={tab.active ? 'active' : ''} >
                <a href={tab.url} >
                  <i id="horizontal-tab" className={`fa-regular ${tab.iconClass} `}> </i>
                  { tab.horizontalTabLabel }
                </a>
              </li>
            )),
          document.getElementById(HORIZONTAL_PLACEHOLDER_DIV)
        )}
    </>
  );
};

export default SideBarHorizontalTabs;
